var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.414,
    height: 22.414,
    viewBox: "0 0 22.414 22.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4347",
    "data-name": "Group 4347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7077",
    "data-name": "Path 7077",
    d: "M18.743,1.735H17.615V.868a.868.868,0,1,0-1.735,0v.868H11.931V.868a.868.868,0,0,0-1.735,0v.868h-3.9V.868a.868.868,0,0,0-1.735,0v.868H3.471A3.475,3.475,0,0,0,0,5.206V18.743a3.475,3.475,0,0,0,3.471,3.471h6.638a.868.868,0,1,0,0-1.735H3.471a1.737,1.737,0,0,1-1.735-1.735V5.206A1.737,1.737,0,0,1,3.471,3.471H4.556v.868a.868.868,0,0,0,1.735,0V3.471h3.9v.868a.868.868,0,0,0,1.735,0V3.471H15.88v.868a.868.868,0,1,0,1.735,0V3.471h1.128a1.737,1.737,0,0,1,1.735,1.735v4.946a.868.868,0,1,0,1.735,0V5.206A3.475,3.475,0,0,0,18.743,1.735Z",
    fill: "#fff",
    stroke: "#182f53",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7078",
    "data-name": "Path 7078",
    d: "M275.25,270a5.25,5.25,0,1,0,5.25,5.25A5.256,5.256,0,0,0,275.25,270Zm0,8.764a3.514,3.514,0,1,1,3.514-3.514A3.518,3.518,0,0,1,275.25,278.764Z",
    transform: "translate(-258.285 -258.286)",
    fill: "#fff",
    stroke: "#182f53",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7079",
    "data-name": "Path 7079",
    d: "M373.126,331.779h-.391v-.911a.868.868,0,1,0-1.735,0v1.779a.868.868,0,0,0,.868.868h1.258a.868.868,0,0,0,0-1.735Z",
    transform: "translate(-354.903 -315.682)",
    fill: "#fff",
    stroke: "#182f53",
    strokeWidth: 0.2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4f6f8f4b820ff0aa4005c5686ec86012.svg";
export { ForwardRef as ReactComponent };